"use client";

import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import PageSection from "@/common/page-section.common";
import { Header } from "@/components";
import { RegisterContext } from "@/context";
import { Stepper, useMediaQuery, Typography } from "@mui/material";
import { StyledStep, StyledStepLabel } from "./register.style";
import RenderRegisterForm from "./render-register-form";

const Register = () => {
  const t = useTranslations();

  const isMobile = useMediaQuery("(max-width: 600px)");
  const [activeStep, setActiveStep] = useState(() => {
    if (typeof window !== "undefined") {
      const savedStep = sessionStorage.getItem("activeStep");
      return savedStep ? parseInt(savedStep, 10) : 0;
    }
    return 0;
  });

  const [mobileNumber, setMobileNumber] = useState("");
  const [aadharNumber, setAadharNumber] = useState("");
  const [userToken, setUserToken] = useState("");

  useEffect(() => {
    sessionStorage.setItem("activeStep", activeStep.toString());
  }, [activeStep]);

  return (
    <RegisterContext.Provider
      value={{
        activeStep,
        setActiveStep,
        mobileNumber,
        setMobileNumber,
        aadharNumber,
        setAadharNumber,
        userToken,
        setUserToken,
      }}
    >
      <Header />

      <PageSection dull>
        <Stepper
          sx={{
            maxWidth: isMobile ? "100%" : "42rem",
            margin: "auto",
            marginBottom: "2rem",
            paddingTop: isMobile ? "4rem" : "6rem",
            transform: isMobile ? "none" : "translateY(-5rem)",
            overflowX: isMobile ? "scroll" : "visible",
          }}
          activeStep={activeStep}
          alternativeLabel
          orientation="horizontal"
        >
          <StyledStep>
            <StyledStepLabel sx={{ fontSize: isMobile ? "0.4rem" : "1rem" }}>
              {t("Basic Information")}
            </StyledStepLabel>
          </StyledStep>
          <StyledStep>
            <StyledStepLabel sx={{ fontSize: isMobile ? "0.5rem" : "1rem" }}>
              {t("OTP Verification")}
            </StyledStepLabel>
          </StyledStep>
          <StyledStep>
            <StyledStepLabel sx={{ fontSize: isMobile ? "0.5rem" : "1rem" }}>
              {t("Upload Documents")}
            </StyledStepLabel>
          </StyledStep>
        </Stepper>

        <RenderRegisterForm />
      </PageSection>

      <PageSection variant="green">
        <Typography sx={{ textAlign: "center" }} color="#fff">
          © {new Date().getFullYear()} {t("Design and developed by 2025 Vidarbha Infotech Private Limited")}
        </Typography>
      </PageSection>
    </RegisterContext.Provider>
  );
};

export default Register;
